import { PropsWithChildren } from "react";
import { cn } from "../../utils/cn";

export const Card = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => (
  <div className={cn("rounded-xl border border-slate-800 bg-slate-900 shadow-lg", className)}>
    {children}
  </div>
);

export const CardHeader = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => (
  <div className={cn("border-b border-slate-800 px-5 py-4", className)}>{children}</div>
);

export const CardContent = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => (
  <div className={cn("px-5 py-4 space-y-4", className)}>{children}</div>
);

export const CardFooter = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => (
  <div className={cn("border-t border-slate-800 px-5 py-3", className)}>{children}</div>
);
